<template>
  <div class="float-nav">
    <div class="nav">
      <img class="daohang-img" src="@/assets/images/daohang.svg" />
      <span>导航网</span>
    </div>
    <el-popover placement="left" trigger="hover">
      <div class="dow-app">
        <img class="dow-img" :src="dowAppUrl || defaultQrCode" alt="二维码" />
      </div>
      <div class="nav" slot="reference">
        <img class="app-img" src="@/assets/images/app.svg" />
        <span>APP下载</span>
      </div>
    </el-popover>
    <div class="nav" @click="$goTo('/feedback')">
      <img class="fk-img" src="@/assets/images/fk.svg" />
      <span>意见反馈</span>
    </div>
    <div class="nav" @click="scrollToTop">
      <img class="top-img" src="@/assets/images/top.svg" />
      <span>返回顶部</span>
    </div>
  </div>
</template>
<script>
import { $goTo } from '@/utils/routerHelper';
import QRCode from 'qrcode'
import { mapState } from 'vuex'

export default {
  name: 'floatNav',

  data() {
    return {
      dowAppUrl: '',
      defaultQrCode: require('@/assets/images/kaiQrCode.png')
    }
  },

  computed: {
    ...mapState(['config']),

    app_url() {
      return this.config?.app_url || ''
    }
  },

  watch: {
    app_url: {
      immediate: true,
      handler(url) {
        if (url) {
          this.generateQrCode(url)
        }
      }
    }
  },

  methods: {
    scrollToTop,
    async generateQrCode(url) {
      try {
        this.dowAppUrl = await QRCode.toDataURL(url, {
          width: 200,
          margin: 1,
          errorCorrectionLevel: 'H'
        })
        // console.log('二维码生成成功')
      } catch (err) {
        console.error('二维码生成失败：', err)
      }
    }
  }
}

/**
 * 滚动到顶部（兼容所有浏览器）
 * @param {number} duration - 动画持续时间（毫秒），默认500ms。设为0则瞬间滚动
 * @param {string} easing - 缓动函数类型：'linear' | 'easeIn' | 'easeOut' | 'easeInOut'，默认'easeOut'
 * @returns {Promise} - 返回Promise，滚动完成后resolve
 */
function scrollToTop(duration = 500, easing = 'easeOut') {
  return new Promise((resolve) => {
    // 获取当前滚动位置（兼容各种浏览器）
    const getScrollTop = () => {
      return window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
    };

    const startY = getScrollTop();

    // 如果已经在顶部，直接返回
    if (startY === 0) {
      resolve();
      return;
    }

    // 瞬间滚动
    if (duration === 0) {
      setScrollTop(0);
      resolve();
      return;
    }

    // 检测浏览器是否支持平滑滚动（原生平滑滚动）
    const supportsNativeSmooth = 'scrollBehavior' in document.documentElement.style;

    // 原生平滑滚动（现代浏览器）
    if (supportsNativeSmooth && duration === 500) {
      try {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        // 延迟resolve，等待滚动完成
        setTimeout(resolve, duration);
        return;
      } catch (e) {
        // 降级到自定义动画
      }
    }

    // 自定义动画（兼容所有浏览器）
    const startTime = performance.now();

    // 缓动函数
    const easingFunctions = {
      linear: (t) => t,
      easeIn: (t) => t * t,
      easeOut: (t) => t * (2 - t),
      easeInOut: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
    };

    const easeFunc = easingFunctions[easing] || easingFunctions.easeOut;

    // 设置滚动位置（兼容各种浏览器）
    const setScrollTop = (value) => {
      window.scrollTo(0, value);
      // 兼容处理
      if (document.documentElement) document.documentElement.scrollTop = value;
      if (document.body) document.body.scrollTop = value;
    };

    // 动画函数
    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = easeFunc(progress);
      const scrollY = startY * (1 - easeProgress);

      setScrollTop(scrollY);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        // 确保最终完全滚动到顶部
        setScrollTop(0);
        resolve();
      }
    };

    requestAnimationFrame(animateScroll);
  });
}
</script>
<style scoped lang="scss">
.dow-app {
  .dow-img {
    width: 124px;
    height: 124px;
  }
}

.float-nav {
  box-shadow: 0 0 15px #d3d3d3;
  position: fixed;
  right: 46px;
  top: 300px;
  z-index: 999;
  background: #fff;
  border-radius: 8px;

  .nav {
    width: 68px;
    height: 68px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: #f2f2f2;

      span {
        color: #000;
      }
    }

    span {
      color: #9e9e9e;
      font-size: 12px;
      margin-top: 10px;
    }

    .daohang-img {
      width: 30px;
      height: 20px;
    }

    .app-img {
      width: 22px;
      height: 22px;
    }

    .fk-img {
      width: 24px;
      height: 24px;
    }

    .top-img {
      width: 17px;
      height: 20px;
    }
  }
}
</style>
